<template>
  <div class="grid-parts__wrap-inner-tools">
    <grid ref="grid" :config="gridConfig" class="no-grid-border">
      <template v-slot:inner-tools>
        <grid-tool-controls
          :controls="gridControls"
          class="inner-tool-controls"
          @command="handleCommand"
        />
      </template>
      <template v-slot:column-control-left="{ row }">
        <li>
          <button
            class="btn"
            @click="sendQuoteToCustomerEmail(row, false)"
          >{{L10n('send-quote-to-customer-email')}}</button>
        </li>
        <template v-if="isViewPrefPendingButton">
          <li>
            <button
              class="btn"
              @click="goToRFQPending(row)"
            >{{L10n('edit-rfq')}}</button>
          </li>
        </template>
      </template>
    </grid>
    <dialog-send-quote-to-customer-email
      ref="dialog-send-quote"
      :rfqID="rfqID"
      :rfq3ID="rfq3ID"
      @onSuccess="onSuccessSendQuoteToCustomerEmail"
    />
    <editor :config="{id: gridConfig.id, api: 'RFQ3s/Get/'}" />
  </div>
</template>

<script>
import gridConfig from './GridConfig'
import models from '@/components/Grid/models'
import { waitValue } from '@/utils/promises'
export default {
  name: 'RFQ3sParts',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'RFQ3sParts' */ './Editor'),
    'dialog-send-quote-to-customer-email': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SendQuoteToCustomerEmail/Index'),
    'grid-tool-controls': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/GridToolControls')
  },
  props: {
    partID: { required: true },
    editorID: { required: true }
  },
  watch: {
    partID: {
      immediate: true,
      handler () {
        this.getGrid()
          .then((grid) => {
            if (this.partID) {
              grid.setFilters(`partID == ${this.partID}`)
              grid.loadData()
            }
          })
      }
    }
  },
  data () {
    return {
      rfqID: null,
      rfq3ID: null,
      gridConfig: gridConfig
    }
  },
  computed: {
    gridControls () {
      return this.$_.merge(models.grid(this.$root).header.controls, {
        isRefresh: true,
        export: {
          json: {
            current: {
              isVisible: false
            },
            all: {
              isVisible: false
            }
          }
        },
        addNew: {
          isVisible: false
        }
      })
    },
    isViewPrefPendingButton () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToViewRFQs')
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    handleCommand () {
      this.getGrid()
        .then((grid) => {
          grid.handleCommand(...arguments)
        })
    },
    sendQuoteToCustomerEmail (row, noStock) {
      const { rfqID, rfq3ID } = row
      this.rfqID = rfqID
      this.rfq3ID = rfq3ID
      this.$nextTick(() => {
        if (!this.rfqID || !this.rfq3ID) return
        this.$refs['dialog-send-quote'].show({ noStock })
      })
    },
    async onSuccessSendQuoteToCustomerEmail () {
      const grid = await this.getGrid()
      grid.refresh()
    },
    goToRFQPending (row) {
      const { href } = this.$router.resolve({ name: 'RFQPendingRFQ', query: { 'rfq-pending': `edit[${row.rfqid}]` } })
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="stylus">
</style>
